'use strict';
import template from './listadoSiprunIbc.html';
import controller from './listadoSiprunIbc.controller';

const ListadoSiprunIbcComponent = {
  controller,
  template
};

export default ListadoSiprunIbcComponent;



// WEBPACK FOOTER //
// ./src/app/components/listados/listadoSiprunIbc/listadoSiprunIbc.component.js